
import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutComponent } from 'app/layout/layouts/empty/empty.component';
import { InitialDataResolver } from 'app/app.resolvers';


// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

    {
        path: 'sign-in',
        pathMatch: 'prefix',
        component: EmptyLayoutComponent,
        loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
    },

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'jogos'},

    // Redirect signed in user to the '/example'
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'jogos'},

    // Auth routes
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: EmptyLayoutComponent,
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)}
        ]
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: EmptyLayoutComponent,
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}
        ]
    },

    // Landing routes
    {
        path: '',
        component: EmptyLayoutComponent,
        children   : [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
            {path: 'bilhete', loadChildren: () => import('app/modules/admin/consultas/consultas.module').then(m => m.ConsultasModule)},
        ]
    },

    {
        path: 'sign-in',
        canActivate: [AuthGuard],
        loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
      },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {path: 'regras', loadChildren: () => import('app/modules/admin/inicio/inicio.module').then(m => m.InicioModule)},
            {path: 'configuracoes', loadChildren: () => import('app/modules/admin/configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule)},
            {path: 'vendedores', loadChildren: () => import('app/modules/admin/usuarios/vendedores/vendedores.module').then(m => m.VendedoresModule)},
            {path: 'gerentes', loadChildren: () => import('app/modules/admin/usuarios/gerentes/gerentes.module').then(m => m.GerentesModule)},
            {path: 'apostadores', loadChildren: () => import('app/modules/admin/usuarios/apostador/apostador.module').then(m => m.ApostadorModule)},
            {path: 'jogos', loadChildren: () => import('app/modules/admin/jogos/jogos.module').then(m => m.JogosModule)},
            {path: 'bilhetes', loadChildren: () => import('app/modules/admin/bilhetes/bilhetes.module').then(m => m.BilhetesModule)},
            {path: 'financeiro', loadChildren: () => import('app/modules/admin/financeiro/financeiro.module').then(m => m.FinanceiroModule)},
            {path: 'caixa', loadChildren: () => import('app/modules/admin/caixa/caixa.module').then(m => m.CaixaModule)},
            {path: 'bloqueios', loadChildren: () => import('app/modules/admin/bloqueios/bloqueios.module').then(m => m.BloqueiosModule)},
            {path: 'cotacoes', loadChildren: () => import('app/modules/admin/cotacoes/cotacoes.module').then(m => m.CotacoesModule)},
            {path: 'adiantamentos', loadChildren: () => import('app/modules/admin/adiantamentos/adiantamentos.module').then(m => m.AdiantamentosModule)},
            {path: 'mapa', loadChildren: () => import('app/modules/admin/mapa/mapa.module').then(m => m.MapaModule)},
            {path: 'perfil', loadChildren: () => import('app/modules/admin/usuarios/perfil/perfil.module').then(m => m.PerfilModule)},
            {path: 'resultados', loadChildren: () => import('app/modules/admin/resultados/resultados.module').then(m => m.ResultadosModule)}
        ]
    }
];
